import { Size } from "@/api/AppApi/common-interfaces/api-enums";

export const getProductBoxDefaultImageDim = (
  size: Size,
): { width: number; height: number } => {
  switch (size) {
    case Size.small:
      return { width: 148, height: 143 };
    case Size.vertical_small:
      return { width: 148, height: 240 };
    case Size.large:
      return { width: 273, height: 200 };
    case Size.vertical_large:
    default:
      return { width: 273, height: 434 };
  }
};

export const getProductBoxDefaultDimAndSpacing = (size: Size) => {
  switch (size) {
    case Size.small:
      return { width: 164, height: 311, spacing: 16 };
    case Size.vertical_small:
      return { width: 164, height: 408, spacing: 16 };
    case Size.large:
      return { width: 300, height: 389, spacing: 32 };
    case Size.vertical_large:
      return { width: 300, height: 623, spacing: 32 };
    default:
      return { width: 164, height: 311, spacing: 16 };
  }
};
